import React, { useState, useEffect } from 'react';
import axios from 'axios';
import { getApiHeader } from 'utlis/commonfunctions';
import sellImages from "../../../../assets/images/sell_physical_recharge_plan_id_17_image.png";
import swal from 'sweetalert';
import { Navigate, useNavigate } from 'react-router-dom';
import { ThreeDots } from 'react-loader-spinner'
import { toast } from 'react-toastify';



const SERVER_URL = process.env.REACT_APP_API_URL;

const styles = {
  wrapper: {
    position: "fixed",
    top: 0,
    left: 0,
    width: "100vw",
    height: "100vh",
    display: "flex",
    justifyContent: "center",
    alignItems: "center",
    backdropFilter: "blur(1px)",
    zIndex: 9999,
  },
};

const CartSection = ({ details, showCart, showCards }) => {
   

  const navigate = useNavigate()
  const [loading, setLoading] = useState(false);

  const [quantities, setQuantities] = useState({});
  const [cartData, setCartData] = useState(details);
  const [dropDownData, setDropDownData] = useState({});
  const [textareaValues, setTextareaValues] = useState({});
  const [controlNumbers, setControlNumbers] = useState([]);
  const [checkoutButton, setCheckoutButton] = useState()
  const [Disable,setDisable]=useState(false)

  console.log("checkout stock",quantities)

  useEffect(() => {
    const initialQuantities = {};
    details?.cart_array?.forEach(item => {
      initialQuantities[item?.plan_id] = item?.stock_quantity || 0;
      setCheckoutButton(item?.stock_quantity)
    });
    setQuantities(initialQuantities);
  }, [details]);


  const handleUpdateCart = async (planId, newQuantity) => {
    const cartData = {
      retailer_id: sessionStorage.getItem('search-ID'),
      plan_id: planId,
      quantity: newQuantity
    };

    try {
      const header = await getApiHeader();
      const response = await axios.post(`${SERVER_URL}sell-physical-recharge-vouchers/add-to-cart`, cartData, { headers: header });
      setCheckoutButton(response.data.data.cart_count_total)
      console.log("response in hndle cart", response.data.data.cart_count_total)
      if(response.data.data.cart_count_total===0){
        setCartData("")
        showCards(false)
        showCart(false)
       }


      handleGoToCart();
    } catch (error) {
      console.error("Error updating cart:", error);
    }
  };

  const incrementQty = (planId) => {
    console.log("planId", planId)
    setQuantities(prevQuantities => {
      const currentQty = prevQuantities[planId] || 0;
      if (currentQty < 30) {
        const newQty = currentQty + 1;
        handleUpdateCart(planId, newQty);
        return { ...prevQuantities, [planId]: newQty };
      }
      return prevQuantities;
    });
  };

  const decrementQty = (planId) => {
    console.log("planId", planId)

    setQuantities(prevQuantities => {
      const currentQty = prevQuantities[planId] || 0;
      if (currentQty > 0) {
        const newQty = currentQty - 1;
        handleUpdateCart(planId, newQty);
        return { ...prevQuantities, [planId]: newQty };
      }
      return prevQuantities;
    });
  };

  const removeItem = async (planId) => {
    setQuantities(prevQuantities => {
      const currentQty = prevQuantities[planId] || 0;
      if (currentQty > 0) {
        const newQty = 0;
        handleUpdateCart(planId, newQty);
        return { ...prevQuantities, [planId]: newQty };
      }
      return prevQuantities;
    });
    try {
      const header = await getApiHeader();
      const formData = {
        retailer_id: sessionStorage.getItem('search-ID'),
        plan_id: planId,
        quantity: 0
      };

      console.log("formdata.retailerid" ,formData.retailer_id)
     const response= await axios.post(`${SERVER_URL}sell-physical-recharge-vouchers/add-to-cart`, formData, { headers: header });
        if(response.status===200){
               console.log("cart count",response.data.data.cart_count_total)
               if(response.data.data.cart_count_total===0){
                setCartData("")
                showCards(false)
                showCart(false)
               }
        }
       
      handleGoToCart();
    } catch (error) {
      console.error("Error removing item from cart:", error);
    }
  };

  const handleGoToCart = async () => {
    try {
      const header = await getApiHeader();
      const formData = {
        retailer_id: sessionStorage.getItem('search-ID'),
      };
      const response = await axios.post(`${SERVER_URL}sell-physical-recharge-vouchers/cart`, formData, { headers: header });
      if (response.status === 200) {
        setCartData(response.data?.data);
      }
    } catch (error) {
      console.error("Error fetching cart data:", error);
    }
  };

  const handleDropDown = async (value, tapPlanId) => {
    setTextareaValues(prevValues => ({ ...prevValues, [tapPlanId]: value }));
    try {
      const header = await getApiHeader();
      const params = new URLSearchParams();
      params.append('plan_id', tapPlanId);
      params.append('control_number', value);
      const response = await axios.get(`${SERVER_URL}sell-physical-recharge-vouchers/search-control-number?${params.toString()}`, {
        headers: header
      });
      if (response.status === 200) {
        setDropDownData(prevData => ({ ...prevData, [tapPlanId]: response.data.data }));
      }
    } catch (error) {
      console.error("Error fetching control numbers:", error);
    }
  };

  // const suggestionHandler = (tapPlanId, newControlNumber) => {
  //       console.log("tapPlanid",tapPlanId)
  //   setControlNumbers(prevControlNumbers => {
  //     const existingNumbers = prevControlNumbers[tapPlanId] || [];
  //     if (!existingNumbers.includes(newControlNumber)) {
  //       return {
  //         ...prevControlNumbers,
  //         [tapPlanId]: [...existingNumbers, newControlNumber]
  //       };
  //     }
  //     return prevControlNumbers;
  //   });
  // };


  // const suggestionHandler = (tapPlanId, newControlNumber) => {
  //   console.log("tapPlanId", tapPlanId);
  //   console.log("suggestion control number",newControlNumber)
  //      const quanti= quantities[tapPlanId]
  //       console.log("details quauntities",quantities)
  //      console.log("qunatiy",quanti)


  //   setControlNumbers(prevControlNumbers => {
    
  //     const newEntry = {
  //       plan_id: tapPlanId,
  //       control_no: newControlNumber
  //     };

      
  //     const exists = prevControlNumbers.some(
  //       entry => entry.plan_id === newEntry.plan_id && entry.control_no === newEntry.control_no
  //     );

    
  //     if (!exists) {
  //       return [...prevControlNumbers, newEntry];
  //     }
  //     return prevControlNumbers;
  //   });
  // };

  const suggestionHandler = (tapPlanId, newControlNumber) => {
    console.log("tapPlanId", tapPlanId);
    console.log("suggestion control number", newControlNumber);
    const availableQuantity = quantities[tapPlanId]; // Quantity of the plan for the given tapPlanId
    console.log("Plan's available quantity", availableQuantity);
  
    setControlNumbers(prevControlNumbers => {
      // Count how many times this control number has been added for this plan
      const controlNumberCountForPlan = prevControlNumbers.filter(
        entry => entry.plan_id === tapPlanId
      ).length;
  
      console.log("Current count of control numbers for this plan:", controlNumberCountForPlan);
  
      // Check if adding another entry would exceed the available quantity
      if (controlNumberCountForPlan >= availableQuantity) {
        console.log("Cannot add more control numbers for this plan, limit reached.");
         toast.error("Cannot add more control numbers for this plan, limit reached.")
        return prevControlNumbers; // Do not update the state if limit is reached
      }
  
      // Create a new entry
      const newEntry = {
        plan_id: tapPlanId,
        control_no: newControlNumber
      };
  
      // Check if this entry already exists
      const exists = prevControlNumbers.some(
        entry => entry.plan_id === newEntry.plan_id && entry.control_no === newEntry.control_no
      );
  
      // If it does not exist, add the new entry
      if (!exists) {
        console.log("Adding new control number entry:", newEntry);
        return [...prevControlNumbers, newEntry];
      }
  
      console.log("Entry already exists, not adding.");
       toast.error("Entry alredy exists")
      return prevControlNumbers; // No changes if the entry already exists
    });
  };




  const handleClear = (tapPlanId, numberToRemove) => {
    console.log(`Removing control number ${numberToRemove} for plan ${tapPlanId}`);
  
    setControlNumbers(prevControlNumbers =>
      prevControlNumbers.filter(control =>
        !(control.plan_id === tapPlanId && control.control_no === numberToRemove)
      )
    );
  };





  // const handleClear = (tapPlanId, numberToRemove) => {
  //   setControlNumbers(prevControlNumbers =>
  //     prevControlNumbers.filter(control =>
  //       !(control.plan_id === tapPlanId && control.control_no === numberToRemove)
  //     )
  //   );
  // };



  const handleCheckout = async () => {
     if(!controlNumbers.length){
      toast.error("please add control numbers before proceeding")
       return
     }

     const totalQuantity = Object.values(quantities).reduce((sum, qty) => sum + qty, 0); // Sum of all quantities
     const totalControlNumbers = controlNumbers.length; // Count of all selected control numbers
   
     console.log("Total quantity:", totalQuantity);
     console.log("Total selected control numbers:", totalControlNumbers);
   
     // Check if the total control numbers match the total quantity
     if (totalControlNumbers !== totalQuantity) {
       console.log("The total number of control numbers does not match the total quantity. Cannot proceed.");
       // Display an error message or avoid the checkout submission
       toast.error("Please ensure the number of control numbers matches the total quantity before proceeding.");
       return; // Stop the checkout API submission
     }









    setLoading(true)
    try {
      const header = await getApiHeader()
      const formData = {
        jsonControlPlanData: controlNumbers,
        retailer_id: sessionStorage.getItem('search-ID')
      }
      const response = await axios.post(`${SERVER_URL}sell-physical-recharge-vouchers/checkout`, formData, { headers: header })
      if (response.status === 200) {
        setCartData("")
        showCards(false)
        showCart(false)
        setLoading(false)
        swal({
          title: "Success",
          text: response.data.message,
          icon: "success",
          button: "Close"
        });


      }

    } catch (error) {
      toast.error(error.response.data.message)
      setLoading(false)

    }
  }






  return (
    <>
      {loading && (
        <div style={styles.wrapper}>
          <ThreeDots
            visible={loading}
            height="80"
            width="80"
            color="#C11D6C"
            radius="9"
            ariaLabel="three-dots-loading"
          />
        </div>
      )}
        
        
      <div className="container cart cart-section">
        <h2 className="text-center mb-4">Confirm Order</h2>
        {cartData?.cart_array?.length > 0 ? (
          <div className="oc-table">
          <div className="table-responsive">
          <table className="table table-bordered">
            <thead className="thead-light">
              <tr>
                <th>Product</th>
                <th>Unit Price</th>
                <th>Qty</th>
                <th>Subtotal</th>
                <th>Discount</th>
                <th>Net Total</th>
                <th></th>
              </tr>
            </thead>
            <tbody>
              {cartData?.cart_array?.map((item, index) => (
                <React.Fragment key={index}>
                  <tr>
                    <td>
                      <img
                        src={item.image}
                        alt={item?.offerName || "Product"}
                        className="img-fluid"
                        style={{ width: '100px' }}
                      />
                      <p style={{ textAlign: "center", color: "black" }}>{item?.offerName}</p>
                    </td>
                    <td>${item?.amount}</td>
                    {/* <td>
                      <button className="btn btn-outline-secondary btn-sm" onClick={() => decrementQty(item?.plan_id) }>-</button>
                      <span className="mx-2">{quantities[item?.tap_plan_id] || item?.stock_quantity || 0}</span>
                      <button className="btn btn-outline-secondary btn-sm" onClick={() => incrementQty(item?.plan_id)}>+</button>
                    </td> */}

                    <td>
                      <button
                        className="btn btn-outline-secondary btn-sm"
                        onClick={() => decrementQty(item?.plan_id)}
                        disabled={controlNumbers.some(control => control.plan_id === item?.plan_id)}
                      >
                        -
                      </button>

                      <span className="mx-2">{quantities[item?.tap_plan_id] || item?.stock_quantity || 0}</span>

                      <button
                        className="btn btn-outline-secondary btn-sm"
                        onClick={() => incrementQty(item?.plan_id)}
                        disabled={controlNumbers.some(control => control.plan_id === item?.plan_id)}
                      >
                        +
                      </button>
                    </td>








                    <td>${item?.sub_total}</td>
                    <td>${item?.discount}</td>
                    <td>${item?.net_total}</td>
                    <td>
                      <button className="btn btn-danger btn-remove" onClick={() => removeItem(item?.plan_id)}> Remove <i class="fa fa-times-circle"></i> </button>
                    </td>
                  </tr>
                  <tr>
                    <td colSpan="7">

                      {/* {controlNumbers[item?.tap_plan_id] && controlNumbers[item?.tap_plan_id].length > 0 && (
                      <ul className="control-dropDown" style={{ display: 'flex', gap: '10px', listStyleType: 'none', padding: 0 }}>
                        {controlNumbers[item?.tap_plan_id].map((data, i) => (
                          <li key={i} onClick={() => suggestionHandler(item?.tap_plan_id, data)} style={{ display: 'flex', alignItems: 'center' }}>
                            <button style={{ position: 'relative', display: 'inline-flex', alignItems: 'center', padding: '8px 16px' }}>
                              {data}
                              <span
                                onClick={(e) => {
                                  e.stopPropagation();
                                  handleClear(item?.tap_plan_id, data);
                                }}
                              >
                                 &#10005;
                              </span>
                            </button>
                          </li>
                        ))}
                      </ul>
                    )} */}

                      {controlNumbers.filter(control => control.plan_id === item?.plan_id).length > 0 && (
                        <ul className="control-dropDown" >
                          {controlNumbers
                            .filter(control => control.plan_id === item?.plan_id)
                            .map((control, i) => (
                              <li key={i} onClick={() => suggestionHandler(control.plan_id, control.control_no)} >
                                <button >
                                  {control.control_no}
                                  <span
                                    onClick={(e) => {
                                      e.stopPropagation();
                                      handleClear(control.plan_id, control.control_no);
                                    }}
                                  >
                                    &#10005;
                                  </span>
                                </button>
                              </li>
                            ))}
                        </ul>
                      )}


                      <textarea
                        className="form-control recharge-value"
                        placeholder="Search and allocate recharge vouchers"
                        rows="3"
                        onChange={(e) => handleDropDown(e.target.value, item?.plan_id)}
                        value={textareaValues[item?.plan_id] || ""}
                      ></textarea>

                    </td>
                  </tr>
                  <tr>
                    <td colSpan="7">
                      {textareaValues[item?.plan_id]?.length > 0 && (
                        <ul className='reacharge-dropDown'>
                          {dropDownData[item?.plan_id]?.map((data, i) => (
                            <li key={i} onClick={() => suggestionHandler(item?.plan_id, data.control_number)} className={data.assign_status === 1 ? 'assigned' : ""}>

                              {data.control_number}
                            </li>
                          ))}
                        </ul>
                      )}
                    </td>
                  </tr>
                </React.Fragment>
              ))}
            </tbody>
          </table>
          </div></div>
        ) : (
          <p className="text-center">Your cart is empty.</p>
        )}

        <div className="row mt-4">
          <div className="col-md-6 address-box">
            <h6>Billing & Delivery Address</h6>
            <p style={{fontWeight:"600"}}>{cartData?.address}</p>
            {/* <p>
            Tobeys Paws <br />
            Kochi, Ernakulam, Edapally, Kerala, 123 <br />
            If the address details are incorrect, please contact <br />
            Telsim Retailer Support to change the delivery address <br />
            before confirming the order.
          </p> */}
          <p style={{fontSize:"small"}}> If the address details are incorrect, please contact Telsim Retailer<br></br> Support to change the delivery address before confirming the order.</p>
          </div>
          <div className="col-md-6">
            <div className="d-flex justify-content-end">
              <table className="table">
                <tbody>
                  <tr>
                    <td style={{textAlign: 'left'}}>Subtotal</td>
                    <td style={{textAlign: 'left'}}>: ${cartData?.cart_total?.sub_total}</td>
                  </tr>
                  <tr>
                    <td style={{textAlign: 'left'}}>Discount Applied</td>
                    <td style={{textAlign: 'left'}}>: - ${cartData?.cart_total?.discount}</td>
                  </tr>
                  <tr>
                    <td style={{textAlign: 'left', fontSize: '20px', fontWeight: '700', color: '#333'}}>Grand Total</td>
                    <td style={{textAlign: 'left', fontSize: '20px', fontWeight: '700', color: '#c11d6c'}}>: ${cartData?.cart_total?.grand_total}</td>
                  </tr>
                </tbody>
              </table>
            </div>
          </div>

          {checkoutButton > 0 ?
            <div className="d-flex justify-content-end mt-3">
              <button className="checkout checkout-btn" onClick={handleCheckout}>Submit Order <i class="fa fa-caret-right"></i></button>
            </div>
            : ""
          }

        </div>


      </div>
    </>
  );
};

export default CartSection;
